import imgBird from './assets/bird.png'
import imgBirdDown from './assets/bird-down2.png'
import imgBirdDead from './assets/bird-dead.png'
import imgBg from './assets/land-bg2.jpg'
import imgBlock1 from './assets/block_1.png'
import imgBlock2 from './assets/block_2.png'
import imgBlock3 from './assets/block_3.png'
import imgBlock4 from './assets/block_4.png'
import imgBlock5 from './assets/block_5.png'
import imgBlock6 from './assets/block_6.png'
import imgBlock7 from './assets/block_7.png'
import imgBlock8 from './assets/block_8.png'
import imgBlock9 from './assets/block_9.png'
import imgBlock10 from './assets/block_10.png'
import imgBlock11 from './assets/block_11.png'
import imgBlock12 from './assets/block_12.png'
import { Engine, Render, Runner, Bodies, Composite, World, Body, Events } from 'matter-js'
import { clamp, last, sample, random, first } from 'lodash'
import { isTouchEnabled } from '../utils/touch'
import { sounds } from '../utils/sounds'

const MODE = 2 // 1 = old way of applying force, 2 = new way of setting velocity

const PIPE_DISTANCE = MODE === 1 ? 250 : 230
const PIPE_SIZE = 80
const PIPE_MOVE_SPEED = 3.4
const PIPE_TEXTURES = [
    imgBlock1,
    imgBlock2,
    imgBlock3,
    imgBlock4,
    imgBlock5,
    imgBlock6,
    imgBlock7,
    imgBlock8,
    imgBlock9,
    imgBlock10,
    imgBlock11,
    imgBlock12,
]

const noop = () => {}
let engine
let render
let bird
let scene
let scoreEl
let gameInstructionsEl
let isAlive = true
let isStarted = false
let score = 0
let stage = 1
let variablePipeDist = PIPE_DISTANCE
let pipes = []
let pipeScorers = []
let resetCb = null

export const resetGame = () => {
    isAlive = true
    isStarted = false
    score = 0
    stage = 1
    variablePipeDist = PIPE_DISTANCE
    // if ( resetCb ) {
    //     resetCb()
    // }

    pipes.forEach( pipe => {
        World.remove( engine.world, pipe );
    } )
    pipes = []

    if ( bird ) {
        World.remove( engine.world, bird );
    }

    bird = Bodies.rectangle(160, scene.clientHeight / 2, 60, 60, {
        friction: 1,
        render: {
            sprite: {
                texture: imgBird,
                yScale: 0.5,
                xScale: 0.5, 
            },
        }
    })
    bird.restitution = 0.7
    World.add( engine.world, bird );

    engine.world.gravity.y = 0

    scoreEl.style.visibility = 'hidden'
    scoreEl.innerHTML = score.toString()

    gameInstructionsEl.style.display = ''
}
// window.resetGame = resetGame

export const startGame = () => {
    engine.world.gravity.y = 1
    if ( MODE === 1 ) {
        Body.applyForce(bird, bird.position, {
            x: 0, 
            y: -0.1
        });
    } else if ( MODE === 2 ) {
        engine.world.gravity.y = 2.5
        // Instead of applying a force, we can also set the velocity
        Body.setVelocity(bird, { x: 0, y: -14 });
    }

    isStarted = true
    scoreEl.style.visibility = 'visible'
    gameInstructionsEl.style.display = 'none'

    // Move game area to middle
    scene.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'center'
    });
}
// window.startGame = startGame

export const initGamearea = (_scene, _scoreEl, _gameInstructionsEl, onGameOver = noop, onRestartStart = noop) => {
    scene = _scene
    scoreEl = _scoreEl
    gameInstructionsEl = _gameInstructionsEl
    const shouldInit = ! engine
    if ( engine ) {
        Engine.clear(engine)
        Render.stop(render)
        World.clear(engine.world)
    }
    engine = Engine.create()
    let canvas = null
    let birdTimeout = null
    let lastGap = 0

    scoreEl.innerHTML = score.toString()

    render = Render.create({
        element: scene,
        engine: engine,
        options: {
            width: scene.clientWidth,
            height: scene.clientHeight,
            background: imgBg,
            wireframes: false,
        }

    });

    var ground = Bodies.rectangle(scene.clientWidth / 2, scene.clientHeight + 20, scene.clientWidth, 60, { 
        isStatic: true,
        render: {
            fillStyle: 'transparent',
        },
    });
    var ceiling = Bodies.rectangle(scene.clientWidth / 2, PIPE_SIZE * -2, scene.clientWidth, 60, { 
        isStatic: true,
        render: {
            // fillStyle: 'transparent',
        },
    });

    // add all of the bodies to the world
    Composite.add(engine.world, [ground, ceiling]);

    // run the renderer
    Render.run(render);

    // create runner
    var runner = Runner.create({ isFixed: true });

    // run the engine
    Runner.run(runner, engine);

    const bumpBird = () => {
        if ( isAlive && isStarted) {
            // Body to apply force to
            var b = bird;

            // Position to apply Force is at  
            // the birds current position
            var p = bird.position;

            if ( MODE === 1 ) {
                // Force vector to be applied
                Body.applyForce(b, p, {
                    x: 0, 
                    y: -0.15
                }); // Either apply force (stacked forces)
            } else if ( MODE === 2 ) {
                // Velocity vector to be applied
                Body.setVelocity(b, {
                    x: 0, 
                    y: -14
                }); // or set velocity (instantaneous
            }

            // Flap.
            bird.render.sprite.texture = imgBirdDown
            clearTimeout(birdTimeout)
            birdTimeout = setTimeout( () => {
                bird.render.sprite.texture = imgBird
            }, 100 )

            sounds.play( 'wingFlap' )
        }
        
        if ( isAlive && ! isStarted ) { 
            startGame()
            sounds.play( 'wingFlap' )
        }
    }

    const handleClick = ev => {
        bumpBird();
        if ( isAlive ) {
            ev.preventDefault()
        }
    }
    const handleTouchstart = ev => {
        bumpBird()
        if ( isAlive ) {
            ev.preventDefault()
        }
    }
    const handleKeydown = ev => {
        if (ev.keyCode === 32) {
            bumpBird();
            if ( isAlive ) {
                ev.preventDefault()
            }
        }
    }

    if ( isTouchEnabled() ) {
        scene.addEventListener('touchstart', handleTouchstart, false);
    } else {
        scene.addEventListener('mousedown', handleClick, false);
    }
    window.addEventListener('keydown', handleKeydown, false);

    const createPipe = ( _gap = null ) => {
        const floorY = render.options.height - 54
        const spawnX = render.options.width + 80
        
        const lowerLimit = 1
        const upperLimit = Math.floor( render.options.height / PIPE_SIZE ) - 3
        const gap = _gap === null ? random( lowerLimit, upperLimit ) : _gap

        let i = 0;
        for ( let y = floorY; y >= - PIPE_SIZE * 2; y -= PIPE_SIZE ) {
            if ( gap === i || gap + 1 === i || gap + 2 === i ) {
                i++
                continue
            }
            i++
            const newPipe = Bodies.rectangle( spawnX, y, 70, 70, {
                isStatic: true,
                render: {
                    sprite: {
                        texture: sample( PIPE_TEXTURES ),
                        yScale: 0.62,
                        xScale: 0.62, 
                    }
                }
            } )

            World.add( engine.world, newPipe );
            pipes.push( newPipe )

            // Take note of a pipe scorer
            if ( y === floorY ) {
                pipeScorers.push( newPipe )
            }
        }

        return gap
    }

    const removePipes = () => {
        const firstPipe = first( pipes )
        if ( firstPipe && firstPipe.position.x < PIPE_SIZE * -2 ) {
            World.remove( engine.world, firstPipe );
            pipes.shift()
        }
    }

    const updateBird = () => {
        // Align the bird
        if ( isAlive ) {
            // Body.setAngle(bird, clamp( bird.velocity.y * 0.6, -0.6, 0.6) )
            const isNeg = bird.velocity.y < -0.2
            // Old bird rotation
            // Body.setAngle(bird, clamp( Math.pow( bird.velocity.y, 2 ) * 0.015 * ( isNeg ? -1 : 1 ), -0.9, 1 ) - 0.3 )
            // New bird rotation
            Body.setAngle(bird, clamp( Math.pow( bird.velocity.y, 2 ) * 0.007 * ( isNeg ? -1 : 1 ), -0.1, 1 ) - 0.3 )

        }
        
        if ( ! canvas ) {
            canvas  = scene.querySelector('canvas')
        }
        if ( isAlive && isStarted ) {
            // Faster if score > 50
            const speed = PIPE_MOVE_SPEED // stage === 1 ? PIPE_MOVE_SPEED : PIPE_MOVE_SPEED + 0.5

            // Comment first because it's laggy
            // canvas.style.backgroundPositionX = `${ (parseFloat( canvas.style.backgroundPositionX ) || 0) - speed }px`

            // Add pipe
            const lastPipe = last( pipes )
            if ( stage === 1 ) {
                if ( ! lastPipe || lastPipe.position.x < render.options.width - PIPE_DISTANCE ) {
                    lastGap = createPipe()
                }
            } else if ( stage > 1 ) {
                if ( ! lastPipe || lastPipe.position.x < render.options.width - variablePipeDist ) {
                    if ( variablePipeDist === PIPE_SIZE / 2 ) {
                        variablePipeDist = PIPE_DISTANCE
                        lastGap = createPipe( lastGap - random( -1, 1 ) )
                    } else {
                        variablePipeDist = PIPE_SIZE / 2
                        lastGap = createPipe()
                    }
                }
            }
            removePipes()

            pipes.forEach( pipe => {
                Body.translate( pipe, { x: -speed, y: 0 })
            })
        }

        if ( isAlive && isStarted ) {
            pipeScorers = pipeScorers.filter( pipe => {
                if ( bird.position.x > pipe.position.x + PIPE_SIZE * 1/4 ) {
                    sounds.play( 'success' )

                    score++
                    if ( score > 50 && stage === 1 ) {
                        stage++
                    }
                    scoreEl.innerHTML = score.toString()
                    return false
                }
                return true
            } )
        }

        if ( ! isAlive ) {
            bird.render.sprite.texture = imgBirdDead
        }
        // (-5^3)/3
        // console.log('updateBird', bird.velocity.y, bird.velocity.y * 9)
    }
    if ( shouldInit ) {
        Events.on(engine, "beforeUpdate", updateBird)
    }

    const onCollision = event => {
        // console.log(bird, [ ...event.pairs ])
        if ( event.pairs.some( ( {bodyA, bodyB}) => bodyA.id === bird.id || bodyB.id === bird.id ) ) {
            if ( isAlive ) {
                isAlive = false
                // getLeaderBoard('flappy-block')
                scoreEl.style.visibility = 'hidden'
                onGameOver( score )
                sounds.play( 'bump' )
            }
            sounds.play( 'smallBump' )
        }
    }
    // if ( shouldInit ) {
        Events.on(engine, "collisionStart", onCollision)
    // }

    if ( resetCb ) {
        resetCb()
    }
    resetGame()
    // startGame()

    resetCb = () => {
        // Render.stop(render)
        // World.clear(engine.world)
        // Engine.clear(engine) // eslint-disable-line
        // render.canvas.remove()
        // render.canvas = null
        // render.context = null
        // render.textures = {}

        scene.removeEventListener('mousedown', handleClick, false);
        scene.removeEventListener('touchstart', handleTouchstart, false);
        window.removeEventListener('keydown', handleKeydown, false);
    }
}

